<template>
  <div id="app">
    <header>
      <nav>
        <router-link to="/">🇫🇷 Français</router-link>
        <router-link to="/en">🇬🇧 English</router-link>
      </nav>
    </header>
    <main>
      <router-view />
    </main>
    <footer>
      <p>&copy; 2026 Damien Gouyette. All rights reserved.</p>
    </footer>
  </div>
</template>

<script setup lang="ts">
// Head tags (title, meta, canonical, hreflang) are declared per view with useSEO.
</script>

<style scoped>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

header {
  background-color: #1a1a1a;
  color: white;
  padding: 1rem 2rem;
}

nav {
  display: flex;
  gap: 2rem;
}

nav a {
  color: white;
  text-decoration: none;
  font-weight: 500;
}

nav a:hover {
  text-decoration: underline;
}

main {
  flex: 1;
  padding: 2rem;
}

footer {
  background-color: #1a1a1a;
  color: white;
  padding: 1rem 2rem;
  text-align: center;
}
</style>

